export type ConnectionStringKey =
	| 'USER ID'
	| 'PASSWORD'
	| 'DRIVER'
	| 'SERVER'
	| 'Data Source'
	| 'PORT'
	| 'DATABASE'
	| 'Provider';
export type ConnectionFormField =
	| 'serverType'
	| 'serverAddress'
	| 'serverAddressOledb'
	| 'port'
	| 'portOledb'
	| 'database'
	| 'serverTypeOledb';

type ParseParamsOledb = {
	str: string;
	name: ConnectionFormField;
	value: string | number;
	fields: Record<'port' | 'serverAddressOledb', string>;
};

type ExecRequest = {
	str: string;
	key: ConnectionStringKey;
	value?: string | number;
};

export class ConnStrReplacer {
	private static getRegexp(key = '\\b') {
		const nonEnclosedValue = '[^=;]*';
		const enclosedVal = '{[^{}]+}';
		const exprField = `${nonEnclosedValue}${key}${nonEnclosedValue}?`;
		const exprValue = `(${enclosedVal}|${nonEnclosedValue})`;
		return new RegExp(`${exprField}= *${exprValue} *;*`, 'gi');
	}

	private static exec(execRequest: ExecRequest): string {
		const { key, str, value = '' } = execRequest;
		let retValue = '';
		const regexp = ConnStrReplacer.getRegexp(key);
		if (!regexp.test(str) && value) retValue = str + `${key}=${value};`;
		else if (!value) retValue = str.replace(regexp, '');
		else retValue = str.replace(regexp, `${key}=${value};`);
		return retValue;
	}

	public static stripProhibited(text: string): string {
		const str = ConnStrReplacer.exec({ key: 'USER ID', str: text });
		return ConnStrReplacer.exec({ key: 'PASSWORD', str });
	}

	public static replace(
		str: string,
		name: ConnectionFormField,
		value: string | number,
	): string {
		switch (name) {
			case 'serverType':
				return ConnStrReplacer.exec({ key: 'DRIVER', str, value });
			case 'serverAddress':
				return ConnStrReplacer.exec({ key: 'SERVER', str, value });
			case 'serverAddressOledb':
				return ConnStrReplacer.exec({ key: 'Data Source', str, value });
			case 'port':
				return ConnStrReplacer.exec({ key: 'PORT', str, value });
			case 'portOledb':
				return ConnStrReplacer.exec({ key: 'PORT', str });
			case 'database':
				return ConnStrReplacer.exec({ key: 'DATABASE', str, value });
			case 'serverTypeOledb':
				return ConnStrReplacer.exec({ key: 'Provider', str, value });
			default:
				return str;
		}
	}

	public static parseOledb(params: ParseParamsOledb): string {
		const { fields, str, value } = params;
		let { name } = params;
		const isPortChanged = name === 'port';
		const driverChanged = name === 'serverType';
		const serverChanged = name === 'serverAddressOledb';
		const validPort = !!fields?.port?.length && fields?.port !== 'NaN';
		let newValue = value;
		let ret = this.replace(str, 'serverType', '');
		ret = this.replace(ret, 'port', '');
		if (serverChanged && validPort) {
			newValue = value ? `${value},${fields.port}` : '';
		} else if (isPortChanged && fields.serverAddressOledb) {
			newValue = `${fields.serverAddressOledb}${
				value ? `,${value}` : ''
			}`;
			ret = this.replace(ret, 'serverAddressOledb', newValue);
			name = 'portOledb';
		} else if (driverChanged) name = 'serverTypeOledb';
		return this.replace(ret, name, newValue);
	}
}
